import { Filter, FilterValues } from '../models';

export const FILTER_PROPERTIES_MAP: Record<keyof FilterValues, keyof Filter> = {
    'frequencies': 'frequency',
    'voltages': 'voltage',
    'efficiencyClasses': 'efficiencyClass',
    'speeds': 'speed',
    'ratedPowerBasedOns': 'ratedPowerBasedOn',
    'powers': 'power',
    'frameMaterials': 'frameMaterial',
    'motorTypes': 'motorType',
    'frameSizes': 'frameSize',
    'mlfbs': 'mlfb',
    'explosionProtections': 'explosionProtection'
};
